import { render, staticRenderFns } from "./StarRatingPicker.vue?vue&type=template&id=ebfc7cf4&scoped=true&"
import script from "./StarRatingPicker.vue?vue&type=script&lang=js&"
export * from "./StarRatingPicker.vue?vue&type=script&lang=js&"
import style0 from "./StarRatingPicker.vue?vue&type=style&index=0&id=ebfc7cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfc7cf4",
  null
  
)

export default component.exports